import React from 'react';
import './Material.css';


const Material = () => (
    <div id="controls">
      <a id="reset-button" href={window.location.href}> &nbsp; </a>
    </div>
);

export default Material;
